import React from "react";

function GuardPatrolling() {
    return (
        <div>
            <h2>Patrolling & Access Control</h2>
            <p>
                Patrolling and access control are core responsibilities of a security guard. This module focuses on how to conduct effective patrols, control entry and exit points, and respond to security breaches.
            </p>

            <h3>Types of Patrols</h3>
            <ul>
                <li><strong>Internal patrols:</strong> Inside buildings and facilities</li>
                <li><strong>External patrols:</strong> Perimeter checks and outdoor areas</li>
                <li><strong>Mobile patrols:</strong> Vehicle-based patrols across multiple sites</li>
                <li><strong>Random patrols:</strong> Unpredictable timing to deter threats</li>
            </ul>

            <h3>Patrolling Techniques</h3>
            <ul>
                <li>Be alert and observant — use all senses</li>
                <li>Check doors, windows, and access points</li>
                <li>Look for signs of forced entry, hazards, or suspicious activity</li>
                <li>Use a patrol log or electronic system to record findings</li>
                <li>Vary routes and timing to avoid predictability</li>
            </ul>

            <h3>Access Control Duties</h3>
            <ul>
                <li>Monitor and control entry/exit points</li>
                <li>Check IDs, passes, or visitor logs</li>
                <li>Issue visitor badges and maintain sign-in records</li>
                <li>Prevent unauthorized access and tailgating</li>
                <li>Use barriers, gates, or electronic systems where applicable</li>
            </ul>

            <h3>Deliveries & Contractors</h3>
            <ul>
                <li>Verify identity and authorization</li>
                <li>Escort visitors or contractors if required</li>
                <li>Log arrival and departure times</li>
                <li>Inspect packages or equipment if policy allows</li>
            </ul>

            <h3>Try It Yourself</h3>
            <p>
                <strong>Scenario:</strong> During a night patrol, you find a fire exit propped open. What steps do you take, and how do you document it?
            </p>

            <h3>Resources</h3>
            <ul>
                <li><a href="https://www.skillsforsecurity.org.uk/" target="_blank" rel="noreferrer">Skills for Security – Patrolling Standards</a></li>
                <li><a href="https://www.hse.gov.uk/toolbox/workplace/security.htm" target="_blank" rel="noreferrer">HSE – Workplace Security</a></li>
                <li><a href="https://www.gov.uk/government/publications/security-operational-requirements" target="_blank" rel="noreferrer">UK Gov – Security Operational Requirements</a></li>
            </ul>
        </div>
    );
}

export default GuardPatrolling;
